// src/pages/Accounts/expenseRecognitionsSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchRecognitions,  
  saveRecognition,
  deleteRecognition,
} from "./expenseRecognitionsThunk";
import { currentDateTime } from "../../lib/functions";

const initialState = {
  entryDate: currentDateTime(),
  list: [],
  recognitionCode: "",
  loading: false,
  error: null,
  selectedRecognition: null,
  isEditRecognition: false,
  refreshList: false,
};

const expenseRecognitionsSlice = createSlice({
  name: "expenseRecognitions",
  initialState,
  reducers: {
    resetRecognitions: () => initialState,
    setEntryDate(state, action) {
      state.entryDate = action.payload;
    },
    setSelectedRecognition(state, action) {
      state.selectedRecognition = action.payload;
    },
    setIsEditRecognition(state, action) {
      state.isEditRecognition = action.payload;
    },
    setRefreshList(state, action) {
      state.refreshList = action.payload;
    },    
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecognitions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRecognitions.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchRecognitions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })      
      .addCase(saveRecognition.fulfilled, (state, action) => {
        state.refreshList = true;
      })
      .addCase(deleteRecognition.fulfilled, (state, action) => {
        state.list = state.list.filter((r) => r.recog_id !== action.payload.id);
      });
  },
});

export const {
  resetRecognitions,
  setEntryDate,
  setSelectedRecognition,
  setIsEditRecognition,
  setRefreshList,
  setRecognitionCode,
} = expenseRecognitionsSlice.actions;

export default expenseRecognitionsSlice.reducer;
